import { render, staticRenderFns } from "./AdminClientsTable.module.vue?vue&type=template&id=4f0a8858&scoped=true&"
import script from "./AdminClientsTable.module.vue?vue&type=script&lang=js&"
export * from "./AdminClientsTable.module.vue?vue&type=script&lang=js&"
import style0 from "./AdminClientsTable.module.vue?vue&type=style&index=0&id=4f0a8858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a8858",
  null
  
)

export default component.exports